import React from "react";

import { useRouterContext, useModirContext } from "@hooks";
import { ILayoutProps, ITitleProps } from "@types";

export interface ILayoutWrapperProps {
  Layout?: React.FC<React.PropsWithChildren<ILayoutProps>>;
  Sider?: React.FC<React.PropsWithChildren>;
  Header?: React.FC<React.PropsWithChildren>;
  Title?: React.FC<React.PropsWithChildren<ITitleProps>>;
  Footer?: React.FC<React.PropsWithChildren>;
  OffLayoutArea?: React.FC<React.PropsWithChildren>;
}

export const LayoutWrapper: React.FC<
  React.PropsWithChildren<ILayoutWrapperProps>
> = ({
  children,
  Layout: LayoutFromProps,
  Sider: SiderFromProps,
  Header: HeaderFromProps,
  Title: TitleFromProps,
  Footer: FooterFromProps,
  OffLayoutArea: OffLayoutAreaFromProps,
}) => {
  const { Layout, Footer, Header, Sider, Title, OffLayoutArea } =
    useModirContext();

  const LayoutToRender = LayoutFromProps ?? Layout as any; //TODO

  return (
    <LayoutToRender
      Sider={SiderFromProps ?? Sider}
      Header={HeaderFromProps ?? Header}
      Footer={FooterFromProps ?? Footer}
      Title={TitleFromProps ?? Title}
      OffLayoutArea={OffLayoutAreaFromProps ?? OffLayoutArea}
    >
      {children}
      {/* <UnsavedPrompt />  TODO */}
    </LayoutToRender>
  );
};
